import { LessonPanelController } from '@/game/prefabs/Lesson/LessonPanelController';
/* START OF COMPILED CODE */

import UIBlocker from "../GeneralUI/UIBlocker";
import MentorUI from "../GeneralUI/MentorUI";
import HUDButton from "../GeneralUI/Buttons/HUDButton";
import DefaultConfirmButton_m from "../DefaultConfirmButton_m";
import DialogueOptionButton_m from "../GeneralUI/Buttons/DialogueOptionButton_m";
import DefaultButton from "../GeneralUI/Buttons/DefaultButton";
import DialogueOptionButton from "./DialogueOptionButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class LessonPanel extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// uiBlocker
		const uiBlocker = new UIBlocker(scene, 0, 0);
		this.add(uiBlocker);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// content_m
		const content_m = scene.add.container(339, 376);
		mobileView.add(content_m);

		// mentorUI_m
		const mentorUI_m = new MentorUI(scene, -223, -76);
		mentorUI_m.scaleX = 0.35;
		mentorUI_m.scaleY = 0.35;
		mentorUI_m.flipX = true;
		mentorUI_m.flipY = false;
		content_m.add(mentorUI_m);

		// dialogueBacking_m
		const dialogueBacking_m = scene.add.nineslice(1, -104, "Hud1", undefined, 302, 90, 8, 8, 8, 8);
		dialogueBacking_m.scaleX = 2;
		dialogueBacking_m.scaleY = 2;
		content_m.add(dialogueBacking_m);

		// headerBacking_m
		const headerBacking_m = scene.add.nineslice(-295, -196, "Hud2", undefined, 160, 24, 4, 4, 4, 8);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		headerBacking_m.setOrigin(0, 0.5);
		content_m.add(headerBacking_m);

		// speaker_name_m
		const speaker_name_m = scene.add.bitmapText(-281, -196, "Aronui", "Guardian Greenleaf");
		speaker_name_m.setOrigin(0, 0.5);
		speaker_name_m.tintTopLeft = 985612;
		speaker_name_m.tintTopRight = 985612;
		speaker_name_m.tintBottomLeft = 985612;
		speaker_name_m.tintBottomRight = 985612;
		speaker_name_m.text = "Guardian Greenleaf";
		speaker_name_m.fontSize = -24;
		content_m.add(speaker_name_m);

		// mainContentContainer_m
		const mainContentContainer_m = scene.add.container(-11, -48);
		content_m.add(mainContentContainer_m);

		// dialogue_text_m
		const dialogue_text_m = scene.add.bitmapText(-274, -116, "Aronui", "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.");
		dialogue_text_m.tintTopLeft = 5387071;
		dialogue_text_m.tintTopRight = 5387071;
		dialogue_text_m.tintBottomLeft = 5387071;
		dialogue_text_m.tintBottomRight = 5387071;
		dialogue_text_m.text = "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.";
		dialogue_text_m.fontSize = -20;
		dialogue_text_m.maxWidth = 450;
		mainContentContainer_m.add(dialogue_text_m);

		// dynamicTextContainer_m
		const dynamicTextContainer_m = scene.add.container(-274, -116);
		mainContentContainer_m.add(dynamicTextContainer_m);

		// controlsContainer_1_m
		const controlsContainer_1_m = scene.add.container(312, -144);
		mainContentContainer_m.add(controlsContainer_1_m);

		// exitButton_1_m
		const exitButton_1_m = new HUDButton(scene, -28, 28, "hud-icons", 133);
		controlsContainer_1_m.add(exitButton_1_m);

		// replayButton_m
		const replayButton_m = new HUDButton(scene, -60, 28, "ui-repeat-button");
		controlsContainer_1_m.add(replayButton_m);

		// nextLineButton_m
		const nextLineButton_m = new DefaultConfirmButton_m(scene, 204, -4);
		mainContentContainer_m.add(nextLineButton_m);

		// dialogueOptionsContainer_m
		const dialogueOptionsContainer_m = scene.add.container(0, -80);
		content_m.add(dialogueOptionsContainer_m);

		// dialogueOptionButton0_m
		const dialogueOptionButton0_m = new DialogueOptionButton_m(scene, 1, -10);
		dialogueOptionsContainer_m.add(dialogueOptionButton0_m);

		// dialogueOptionButton1_m
		const dialogueOptionButton1_m = new DialogueOptionButton_m(scene, 1, 34);
		dialogueOptionsContainer_m.add(dialogueOptionButton1_m);

		// optionPromptText_m
		const optionPromptText_m = scene.add.bitmapText(-285, -84, "Aronui", "What would you like to talk about?");
		optionPromptText_m.tintTopLeft = 5387071;
		optionPromptText_m.tintTopRight = 5387071;
		optionPromptText_m.tintBottomLeft = 5387071;
		optionPromptText_m.tintBottomRight = 5387071;
		optionPromptText_m.text = "What would you like to talk about?";
		optionPromptText_m.fontSize = -20;
		dialogueOptionsContainer_m.add(optionPromptText_m);

		// controlsContainer_m
		const controlsContainer_m = scene.add.container(301, -112);
		dialogueOptionsContainer_m.add(controlsContainer_m);

		// exitButton_m
		const exitButton_m = new HUDButton(scene, -28, 28, "hud-icons", 133);
		controlsContainer_m.add(exitButton_m);

		// lessonIconContainer_m
		const lessonIconContainer_m = scene.add.container(260, 32);
		mobileView.add(lessonIconContainer_m);

		// visualAidCards_m
		const visualAidCards_m = scene.add.container(20, 48);
		lessonIconContainer_m.add(visualAidCards_m);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// content
		const content = scene.add.container(512, 604);
		desktopView.add(content);

		// mentorUI
		const mentorUI = new MentorUI(scene, 264, -88);
		mentorUI.scaleX = 0.5;
		mentorUI.scaleY = 0.5;
		content.add(mentorUI);

		// dialogueBacking
		const dialogueBacking = scene.add.nineslice(0, -8, "Hud1", undefined, 176, 74, 8, 8, 8, 8);
		dialogueBacking.scaleX = 4;
		dialogueBacking.scaleY = 4;
		content.add(dialogueBacking);

		// headerBacking
		const headerBacking = scene.add.nineslice(-288, -152, "Hud2", undefined, 80, 16, 8, 8, 8, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		headerBacking.setOrigin(0, 0.5);
		content.add(headerBacking);

		// speaker_name
		const speaker_name = scene.add.bitmapText(-132, -152, "Aronui", "Guardian Greenleaf");
		speaker_name.setOrigin(0.5, 0.5);
		speaker_name.tintTopLeft = 985612;
		speaker_name.tintTopRight = 985612;
		speaker_name.tintBottomLeft = 985612;
		speaker_name.tintBottomRight = 985612;
		speaker_name.text = "Guardian Greenleaf";
		speaker_name.fontSize = -24;
		content.add(speaker_name);

		// mainContentContainer
		const mainContentContainer = scene.add.container(0, 16);
		content.add(mainContentContainer);

		// dialogue_text
		const dialogue_text = scene.add.bitmapText(-288, -60, "Aronui", "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.");
		dialogue_text.tintTopLeft = 5387071;
		dialogue_text.tintTopRight = 5387071;
		dialogue_text.tintBottomLeft = 5387071;
		dialogue_text.tintBottomRight = 5387071;
		dialogue_text.text = "Welcome spellcaster to my realm! Today we are going to be learning about phonemes.";
		dialogue_text.fontSize = -24;
		dialogue_text.maxWidth = 600;
		mainContentContainer.add(dialogue_text);

		// nextLineButton
		const nextLineButton = new DefaultButton(scene, 192, 72);
		mainContentContainer.add(nextLineButton);

		// dynamicTextContainer
		const dynamicTextContainer = scene.add.container(-288, -64);
		mainContentContainer.add(dynamicTextContainer);

		// controlsContainer_1
		const controlsContainer_1 = scene.add.container(352, -160);
		controlsContainer_1.scaleX = 2;
		controlsContainer_1.scaleY = 2;
		mainContentContainer.add(controlsContainer_1);

		// exitButton_1
		const exitButton_1 = new HUDButton(scene, -24, 24, "hud-icons", 133);
		controlsContainer_1.add(exitButton_1);

		// replayButton
		const replayButton = new HUDButton(scene, -60, 24, "ui-repeat-button");
		controlsContainer_1.add(replayButton);

		// dialogueOptionsContainer
		const dialogueOptionsContainer = scene.add.container(0, 52);
		content.add(dialogueOptionsContainer);

		// dialogueOptionButton0
		const dialogueOptionButton0 = new DialogueOptionButton(scene, 0, -20);
		dialogueOptionsContainer.add(dialogueOptionButton0);

		// dialogueOptionButton1
		const dialogueOptionButton1 = new DialogueOptionButton(scene, 0, 36);
		dialogueOptionsContainer.add(dialogueOptionButton1);

		// optionPromptText
		const optionPromptText = scene.add.bitmapText(-280, -96, "Aronui", "What would you like to talk about?");
		optionPromptText.tintTopLeft = 5387071;
		optionPromptText.tintTopRight = 5387071;
		optionPromptText.tintBottomLeft = 5387071;
		optionPromptText.tintBottomRight = 5387071;
		optionPromptText.text = "What would you like to talk about?";
		optionPromptText.fontSize = -24;
		dialogueOptionsContainer.add(optionPromptText);

		// controlsContainer
		const controlsContainer = scene.add.container(-512, -636);
		controlsContainer.scaleX = 2;
		controlsContainer.scaleY = 2;
		dialogueOptionsContainer.add(controlsContainer);

		// exitButton
		const exitButton = new HUDButton(scene, 408, 244, "hud-icons", 133);
		controlsContainer.add(exitButton);

		// lessonIconContainer
		const lessonIconContainer = scene.add.container(0, 0);
		desktopView.add(lessonIconContainer);

		// visualAidCards
		const visualAidCards = scene.add.container(0, 0);
		lessonIconContainer.add(visualAidCards);

		// exitButton_1_m (prefab fields)
		exitButton_1_m.useAlternateTextures = false;

		// replayButton_m (prefab fields)
		replayButton_m.useAlternateTextures = false;

		// nextLineButton_m (prefab fields)
		nextLineButton_m.buttonText = "Next";

		// dialogueOptionButton0_m (prefab fields)
		dialogueOptionButton0_m.buttonText = "Level 1 Lesson";

		// dialogueOptionButton1_m (prefab fields)
		dialogueOptionButton1_m.buttonText = "Daily Activities";

		// exitButton_m (prefab fields)
		exitButton_m.useAlternateTextures = false;

		// nextLineButton (prefab fields)
		nextLineButton.buttonText = "Next";

		// exitButton_1 (prefab fields)
		exitButton_1.useAlternateTextures = false;

		// replayButton (prefab fields)
		replayButton.useAlternateTextures = false;

		// dialogueOptionButton0 (prefab fields)
		dialogueOptionButton0.ButtonLabel = "Level 1 Lesson";

		// dialogueOptionButton1 (prefab fields)
		dialogueOptionButton1.ButtonLabel = "Daily Activities";

		// exitButton (prefab fields)
		exitButton.useAlternateTextures = false;

		this.mentorUI_m = mentorUI_m;
		this.speaker_name_m = speaker_name_m;
		this.dialogue_text_m = dialogue_text_m;
		this.dynamicTextContainer_m = dynamicTextContainer_m;
		this.exitButton_1_m = exitButton_1_m;
		this.replayButton_m = replayButton_m;
		this.nextLineButton_m = nextLineButton_m;
		this.mainContentContainer_m = mainContentContainer_m;
		this.dialogueOptionButton0_m = dialogueOptionButton0_m;
		this.dialogueOptionButton1_m = dialogueOptionButton1_m;
		this.exitButton_m = exitButton_m;
		this.dialogueOptionsContainer_m = dialogueOptionsContainer_m;
		this.content_m = content_m;
		this.visualAidCards_m = visualAidCards_m;
		this.lessonIconContainer_m = lessonIconContainer_m;
		this.mobileView = mobileView;
		this.mentorUI = mentorUI;
		this.speaker_name = speaker_name;
		this.dialogue_text = dialogue_text;
		this.nextLineButton = nextLineButton;
		this.dynamicTextContainer = dynamicTextContainer;
		this.exitButton_1 = exitButton_1;
		this.replayButton = replayButton;
		this.mainContentContainer = mainContentContainer;
		this.dialogueOptionButton0 = dialogueOptionButton0;
		this.dialogueOptionButton1 = dialogueOptionButton1;
		this.exitButton = exitButton;
		this.dialogueOptionsContainer = dialogueOptionsContainer;
		this.content = content;
		this.visualAidCards = visualAidCards;
		this.lessonIconContainer = lessonIconContainer;
		this.desktopView = desktopView;

		/* START-USER-CTR-CODE */

    this._controller = new LessonPanelController(this);

    /* END-USER-CTR-CODE */
	}

	public mentorUI_m: MentorUI;
	public speaker_name_m: Phaser.GameObjects.BitmapText;
	public dialogue_text_m: Phaser.GameObjects.BitmapText;
	public dynamicTextContainer_m: Phaser.GameObjects.Container;
	public exitButton_1_m: HUDButton;
	public replayButton_m: HUDButton;
	public nextLineButton_m: DefaultConfirmButton_m;
	public mainContentContainer_m: Phaser.GameObjects.Container;
	public dialogueOptionButton0_m: DialogueOptionButton_m;
	public dialogueOptionButton1_m: DialogueOptionButton_m;
	public exitButton_m: HUDButton;
	public dialogueOptionsContainer_m: Phaser.GameObjects.Container;
	public content_m: Phaser.GameObjects.Container;
	public visualAidCards_m: Phaser.GameObjects.Container;
	public lessonIconContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;
	public mentorUI: MentorUI;
	public speaker_name: Phaser.GameObjects.BitmapText;
	public dialogue_text: Phaser.GameObjects.BitmapText;
	public nextLineButton: DefaultButton;
	public dynamicTextContainer: Phaser.GameObjects.Container;
	public exitButton_1: HUDButton;
	public replayButton: HUDButton;
	public mainContentContainer: Phaser.GameObjects.Container;
	public dialogueOptionButton0: DialogueOptionButton;
	public dialogueOptionButton1: DialogueOptionButton;
	public exitButton: HUDButton;
	public dialogueOptionsContainer: Phaser.GameObjects.Container;
	public content: Phaser.GameObjects.Container;
	public visualAidCards: Phaser.GameObjects.Container;
	public lessonIconContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  private _controller: LessonPanelController;
  get controller() {
    return this._controller;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
